module.exports = __webpack_public_path__ + "static/media/tech-icon-game.abe0d40f.svg";